module.exports = __webpack_public_path__ + "img/csbb1@2x.7bcad4f4.png";